import { asyncComponent } from "@jaredpalmer/after";
import { getRemoteConfigValue } from "@/modules/app/useRemoteConfig";

export const DEFAULT_ROUTE = "/feed";

const routes = [
  {
    path: "/",
    exact: true,
    component: asyncComponent({
      loader: () => import("./NopRoute"),
    }),
    redirectTo: DEFAULT_ROUTE,
  },
  ...(getRemoteConfigValue("feed_enabled", true)
    ? [
        {
          path: "/feed",
          exact: true,
          component: asyncComponent({
            loader: () => import("./Feed"),
          }),
        },
        {
          path: "/feed/:id",
          exact: true,
          component: asyncComponent({
            loader: () => import("./FeedPost"),
          }),
        },
      ]
    : []),
  ...(getRemoteConfigValue("login_enabled", true)
    ? [
        {
          path: "/user/:id",
          component: asyncComponent({
            loader: () => import("./Profile"),
          }),
        },
      ]
    : []),
  {
    component: asyncComponent({
      loader: () => import("./NopRoute"),
    }),
  },
];

export default routes;
